module.exports = __webpack_public_path__ + "static/media/paleta.3036edbf.jpeg";